import React from 'react';
import './ProgressBar.css';

function ProgressBar({ value, max = 100, label, showLabel = true, color = 'primary', size = 'medium' }) {
  const percentage = Math.min((value / max) * 100, 100);

  return (
    <div className={`progress-bar-container size-${size}`}>
      {showLabel && label && (
        <div className="progress-bar-label">
          <span>{label}</span>
          <span className="progress-bar-percentage">{Math.round(percentage)}%</span>
        </div>
      )}
      <div className="progress-bar-track">
        <div
          className={`progress-bar-fill color-${color}`}
          style={{ width: `${percentage}%` }}
        >
          {!showLabel && <span className="progress-bar-text">{Math.round(percentage)}%</span>}
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;

